// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3xCCE","clinicsSelect":"TableHeading_clinicsSelect__1IjXH"};